var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"tw-circle-back",on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.handleBack).apply(void 0, arguments)
}}},[_c('i',{staticClass:"tripwise_outline icon-arrowdn_outline"})])}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }